import React from "react";
import { Mail, CheckCircle2 } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const current = JSON.parse(localStorage.getItem("3e_newsletter_list") || "[]");
      if (!current.some(s => s.email === email)) {
        current.push({ email, at: Date.now() });
        localStorage.setItem("3e_newsletter_list", JSON.stringify(current));
      }
    } catch {}
    setSent(true);
    setTimeout(() => setSent(false), 3200);
    setEmail("");
  };

  return (
    <section className="py-24">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="card-soft p-10 md:p-14 relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#c7e34a]/10 blur-3xl" />
          <div className="relative">
            <span className="kicker"><Mail className="w-3.5 h-3.5" /> A daily note of care</span>
            <h3 className="font-serif-display text-4xl md:text-5xl text-white mt-4 mb-4">Bring a little encouragement to your inbox.</h3>
            <p className="text-slate-300 max-w-2xl mb-8">Subscribe for daily health-and-care quotations, gentle reminders, and words about compassion from Dazile Auguste and the 3E DanCare circle.</p>

            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl">
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address" required
                className="flex-1 bg-[#0b1220] border border-white/10 rounded-full px-5 py-3.5 text-white placeholder:text-slate-500 focus:outline-none focus:border-[#c7e34a]/60"
              />
              <button type="submit" className="btn-lime justify-center">Subscribe</button>
            </form>

            {sent && (
              <div className="mt-5 flex items-center gap-2 text-[#c7e34a] text-sm">
                <CheckCircle2 className="w-4 h-4" /> Thank you — we'll be in touch with a gentle note soon.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
